import * as yup from 'yup';

export const addJourneyCompletionRewardSchema = yup.object({
  addJourneyCompletionReward: yup.object({
    accountReferral: yup.object({
      id: yup.string().required(),
    }),
  }),
});
